<template>
    <div class="content">
        <div class="title">填写要接收的文件密钥</div>

        <canvas ref="canvas" style="display: none"></canvas>
        <div class="titInpt">
            <el-input
                class="inpt"
                v-model="code"
                placeholder="输入密钥"
                @input="getFile"
            ></el-input>
            <input
                type="file"
                accept="image/*"
                @change="handleFileUpload"
                ref="fileInput"
                style="display: none"
            />
            <img src="../assets/images/ewm.png" alt="" @click="uploading" />
        </div>
        <div class="tip">
            使用指南
            <img src="../assets/images/zn.png" alt="" />
        </div>
        <el-dialog title="接收的文件" :visible.sync="fileListFlag">
            <div class="fileList">
                <div
                    class="fileListLi"
                    v-for="(item, index) in dataList"
                    :key="index"
                >
                    <div class="fileListtext">
                        文件名称：{{ item.fileName }}
                    </div>
                    <div class="fileListtext">
                        文件大小：{{ item.fileSize }}
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="fileListFlag = false">取 消</el-button>
                    <el-button type="primary" @click="sureFile"
                        >确 定 接 收</el-button
                    >
                </div>
            </div>
        </el-dialog>

        <el-dialog title="提示" :visible.sync="wenjian" width="30%">
            <span>当前文件已大于10MB，请下载APP使用。</span>
            <p>
                下载地址<a href="http://96.9.231.213:8092/秒达.apk"
                    >http://96.9.231.213:8092/秒达.apk</a
                >
            </p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="wenjian = false">取 消</el-button>
                <el-button type="primary" @click="goDown">去 下 载</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
// confirmReceive
import jsQR from 'jsqr'
import { listFileByCode, confirmReceive, getConfig } from '@/api/index'
export default {
    data() {
        return {
            wenjian: false,
            fileListFlag: false,
            code: '',
            dataList: [],
            decodedText: '',
            maxSize: 0
        }
    },
    created() {
        if (this.$route.query.code) {
            localStorage.setItem('code', this.$route.query.code)
        }
        if (localStorage.getItem('code')) {
            this.code = localStorage.getItem('code')
            this.getFile()

            localStorage.removeItem('code')
        }

        this.getSize()
    },

    methods: {
        goDown() {
            this.wenjian = false
            window.open('http://96.9.231.213:8092/秒达.apk', '_blank')
        },
        onvertSizeToBytes(sizeStr) {
            const units = {
                B: 1,
                KB: 1024,
                MB: 1024 * 1024,
                GB: 1024 * 1024 * 1024,
                TB: 1024 * 1024 * 1024 * 1024
            }

            // 正则匹配数字和单位
            const match = sizeStr.match(/^([\d.]+)\s*([KMGTP]?B)$/i)
            if (!match) return 0

            const num = parseFloat(match[1])
            const unit = match[2].toUpperCase()

            return num * (units[unit] || 1)
        },

        // 上传
        uploading() {
            this.$refs['fileInput'].click()
        },
        handleFileUpload(event) {
            const file = event.target.files[0]
            if (!file) return
            console.log(file, '选择的文件')

            const reader = new FileReader()
            reader.onload = (e) => {
                this.decodeQRCode(e.target.result)
            }
            reader.readAsDataURL(file)
        },
        decodeQRCode(imageSrc) {
            const canvas = this.$refs.canvas
            const ctx = canvas.getContext('2d')
            const image = new Image()

            image.onload = () => {
                canvas.width = image.width
                canvas.height = image.height
                ctx.drawImage(image, 0, 0)
                const imageData = ctx.getImageData(
                    0,
                    0,
                    canvas.width,
                    canvas.height
                )
                const code = jsQR(
                    imageData.data,
                    imageData.width,
                    imageData.height
                )

                this.code = code ? code.data : '识别失败'
                this.getFile()
            }
            image.src = imageSrc
        },
        sureFile() {
            confirmReceive({ code: this.code }).then((res) => {
                if (res.code == 0) {
                    this.$message({
                        message: '接收成功',
                        type: 'success'
                    })
                    this.fileListFlag = false
                    this.code = ''
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    })
                }
            })
        },
        // 获取设定的大小
        getSize() {
            getConfig({ key: 'maxSize' }).then((res) => {
                // console.log(res, '234234523')
                this.maxSize = res.data
            })
        },

        getFile() {
            if (this.code.length != 6) {
                // this.$message({
                //     message: '请输入正确的密钥',
                //     type: 'error'
                // })
                return
            }

            console.log(this.code.length)
            listFileByCode({ code: this.code }).then((res) => {
                if (res.code == 0) {
                    this.dataList = res.data
                    let array = []
                    let sums = 0
                    for (var a = 0; a < res.data.length; a++) {
                        // array.push(this.onvertSizeToBytes(res.data[a].fileSize))
                        array.push(
                            parseFloat(
                                res.data[a].fileSize.trim().split(/\s+/)[0]
                            )
                        )
                    }
                    for (let i = 0; i < array.length; i++) {
                        sums += array[i]
                    }
                    // console.log(array)
                    // console.log(sums)
                    if (sums > this.maxSize) {
                        this.wenjian = true
                    } else {
                        this.fileListFlag = true
                    }
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    })
                }
            })
            // if (this.code) {
            // }
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    text-align: center;
    display: flex;
    align-items: center;

    justify-content: center;

    flex-direction: column;
    height: calc(100vh - 100px);
}
.title {
    color: #1d1d1d;
    font-size: 36px;
    font-weight: 400;
    font-family: 'HarmonyOSSansSC';
}
.titInpt {
    width: 828px;
    height: 99px;
    border-radius: 16px;
    opacity: 1;
    background: linear-gradient(90deg, #f7f8f9 0%, #f7f8f9 100%);
    margin: 0 auto;
    margin-top: 52px;
    display: flex;

    align-items: center;
    padding: 0 30px;
    box-sizing: border-box;

    img {
        width: 58px;
        height: 58px;
    }
}
.tip {
    color: #9a9a9a;
    font-size: 18px;
    font-weight: 400;
    font-family: 'HarmonyOSSansSC';
    display: flex;

    align-items: center;
    justify-content: flex-start;
    width: 828px;
    margin-top: 28px;

    img {
        width: 22px;
        height: 22px;

        margin-left: 10px;
    }
}
::v-deep .el-input__inner {
    border: none !important;
    background: none;
    font-size: 24px;
}

.fileList {
    .fileListLi {
        border-bottom: 1px solid #dedede;
        padding: 20px;
        box-sizing: border-box;
        .fileListtext {
            text-align: left;
        }
    }
}
.dialog-footer {
    display: flex;
    align-items: center;

    justify-content: flex-end;
    margin-top: 20px;
}
/* 移动端适配 (max-width: 768px) */
@media screen and (max-width: 768px) {
    .content {
        height: calc(100vh - 60px) !important;
        padding: 40px 20px 0 !important;
        justify-content: flex-start !important;
        box-sizing: border-box;
    }

    .title {
        font-size: 24px !important;
        width: 100%;
        text-align: center;
    }

    .titInpt {
        width: 100% !important;
        height: 70px !important;
        margin-top: 30px !important;
        padding: 0 15px !important;

        .inpt {
            ::v-deep .el-input__inner {
                font-size: 18px !important;
            }
        }

        img {
            width: 40px !important;
            height: 40px !important;
        }
    }

    .tip {
        width: 100% !important;
        font-size: 14px !important;
        margin-top: 20px !important;

        img {
            width: 16px !important;
            height: 16px !important;
        }
    }

    /* 对话框调整 */
    ::v-deep .el-dialog {
        width: 90% !important;

        &__header {
            padding: 15px 20px;
        }

        &__body {
            padding: 15px;
        }

        .fileListLi {
            padding: 15px 0 !important;
        }
    }

    .dialog-footer {
        flex-direction: column;
        align-items: stretch;

        .el-button {
            width: 100%;
            margin: 5px 0 !important;
        }
    }
}
</style>